<template>
  <div>
    <section class="authentication-form">
      <div>
        <h2 class="title text-center">
          RESET YOUR<span> PASSWORDS</span>
        </h2>
        <div class="card">
          <form
            class="theme-form"
            @submit.prevent
          >
            <div class="form-group">
              <input
                v-model="input.password"
                required=""
                type="password"
                class="form-control"
                placeholder="Password"
              >
            </div>
            <div class="form-group">
              <input
                :type="showpassword ? 'password' : 'text'"
                required="required"
                name="login[retype_password]"
                class="form-control"
                placeholder="Retype password"
              >
              <div
                class="show-hide"
                @click="showpassword = !showpassword"
              >
                <span :class="{show:showpassword}" />
              </div>
            </div>
            <div class="form-button text-center">
              <button
                type="submit"
                class="btn btn-custom theme-color"
                @click="reset"
              >
                Done
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      showpassword: true,
      token: this.$route.query.token,
      input: {
        password: null,
      },
    }
  },
  methods: {
    reset() {
      this.axios
        .post(`${process.env.ROOT_API}/user/reset/${this.token}`, {
          password: this.input.password,
        })
        .then(response => {
          this.$router.push({ name: 'Home' })
        })
        .catch(error => {
          this.$toasted.show('An error occurred please try again')
        })
    },
  },
}
</script>
<style scoped>
.form-control{
  background-color: #d6fff1 !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/reset_password.vue